import {
  api_autocomplete_entities_path,
  api_create_entity_path,
  api_entity_blurb_path,
} from '../../routes';
import request from './request';

export const TOPIC_DESCRIPTION_KEY = 'TOPIC_DESCRIPTION_KEY';

export interface SanitizedAutocompleteEntityParams {
  fragment: string;
  entity_type?: string;
  word_type?: string;
  entity_source_attribute?: string;
  order_entities_by?: string[];
  entity_sources?: string[];
  match_type?: string;
}

export interface EntityBlurbRequestParams {
  entity_id: number;
}

export interface EntityBlurbResponse {
  blurb?: string;
  is_ai?: boolean;
  message?: string;
}

export interface EntityObj {
  field: string;
  value: number;
}

export const MATCH_EXACT = 'exact';
export const MATCH_SLUG = 'slug';
export const MATCH_FUZZY = 'fuzzy';

export async function autocompleteEntities(
  values: SanitizedAutocompleteEntityParams
): Promise<EntityObj[]> {
  const resp = await request('get', api_autocomplete_entities_path(values));
  return resp.entities;
}

export interface SanitizedEntityParams {
  name: string;
  entity_type: string;
  word_type: string;
}

type createEntityResponse = { success: boolean; id?: number; errors?: string };

export async function createEntity(values: SanitizedEntityParams): Promise<createEntityResponse> {
  const resp = await request('post', api_create_entity_path(values));
  return resp;
}

export async function fetchEntityBlurb(
  params: EntityBlurbRequestParams
): Promise<EntityBlurbResponse> {
  const resp = await request('get', api_entity_blurb_path(params));
  return resp;
}
